import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const Aromatherapy = () => {
  return <AstroStaticPage data={Data} />;
};

export default Aromatherapy;
